import { h } from "@stencil/core";
import { ButtonType } from "../../shared/models/atoms/bbg-button/button-type.enum";
import { renderInlineError } from "../../../utils";
export class BbgButton {
  constructor() {
    this.type = ButtonType.primary;
    this.label = undefined;
    this.buttonAriaLabel = undefined;
    this.fixed = false;
    this.disabled = false;
  }
  render() {
    if (ButtonType[this.type] === undefined) {
      return renderInlineError(`Unknown button type '${this.type}'`);
    }
    const iconExists = this.hostElement.querySelector("bbg-icon") !== null;
    const buttonCssClasses = {
      "a-button": true,
      "a-button--primary": this.type === ButtonType.primary,
      "a-button--secondary": this.type === ButtonType.secondary,
      "a-button--tertiary": this.type === ButtonType.tertiary,
      "a-button--integrated": this.type === ButtonType.integrated,
      "-fixed": this.fixed,
      "-without-icon": !iconExists,
      "-without-label": !this.label,
    };
    return (h("button", { type: "button", disabled: this.disabled, class: buttonCssClasses, "aria-label": this.buttonAriaLabel }, h("slot", null), this.label ? h("div", { class: "a-button__label" }, this.label) : ""));
  }
  static get is() { return "bbg-button"; }
  static get originalStyleUrls() {
    return {
      "$": ["bbg-button.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["bbg-button.css"]
    };
  }
  static get properties() {
    return {
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The button's type. Possible values: primary, secondary, tertiary, close"
        },
        "attribute": "type",
        "reflect": false,
        "defaultValue": "ButtonType.primary"
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The label of the button"
        },
        "attribute": "label",
        "reflect": false,
        "defaultValue": "undefined"
      },
      "buttonAriaLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The aria-label of the button. Usually only buttons without labels need this."
        },
        "attribute": "button-aria-label",
        "reflect": false,
        "defaultValue": "undefined"
      },
      "fixed": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Gives the button a fixed width. Thereby too long labels get truncated"
        },
        "attribute": "fixed",
        "reflect": false,
        "defaultValue": "false"
      },
      "disabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Disables the button"
        },
        "attribute": "disabled",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get elementRef() { return "hostElement"; }
}
